import { setShowBalances } from "@/modules/dashboard/state";
import type { IStock } from "@/modules/stock/common/types";
import { useGetStocksQuery } from "@/modules/stock/services";
import type { IError } from "@/shared/common/types";
import { FinanceItem, PageWidgetTemplate } from "@/shared/components";
import { useAppDispatch, useShowBalance } from "@/shared/hooks";
import classNames from "classnames";
import { type Dispatch, type SetStateAction, useEffect } from "react";

interface Props {
  limit?: number;
  isDetailOpen?: boolean;
  selectedStock?: IStock | null;
  setSelectedStock?: Dispatch<SetStateAction<IStock | null>>;
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

export const Stocks = ({
  limit,
  isDetailOpen,
  selectedStock,
  setSelectedStock,
  setIsOpen,
}: Props) => {
  const dispatch = useAppDispatch();
  const { handleShowBalances } = useShowBalance();
  const {
    data: stocks,
    isFetching,
    isError,
    error,
    refetch,
  } = useGetStocksQuery({
    pageSize: limit,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const onShowDetails = (stock: IStock) => {
    setSelectedStock?.(stock);
    if (!isDetailOpen) {
      setIsOpen?.(true);
    }
  };

  useEffect(() => {
    if (stocks?.length) {
      const showBalances = Array(stocks?.length).fill(false);
      dispatch(setShowBalances(showBalances));
    }
  }, [stocks]);

  return (
    <PageWidgetTemplate
      isFetching={isFetching}
      isError={isError}
      error={error as IError}
      refetch={refetch}
      isEmpty={!stocks?.length}
    >
      {stocks?.map((stock, i) => (
        <div key={stock.contractNumber} onClick={() => onShowDetails(stock)}>
          <FinanceItem
            {...stock}
            index={i}
            handleShowBalances={handleShowBalances}
            className={classNames({ "selected": selectedStock?.id === stock.id })}
          />
        </div>
      ))}
    </PageWidgetTemplate>
  );
};
